export const SIGHT = 'SIGHT';
